import { h } from 'preact';

import MovieHeaderEditor from 'components/editor/movies/movieHeader/movieHeader';
import FocusFeaturesLogo from 'components/cms/icons/focusFeaturesLogo';

import s from 'components/editor/movies/movieHeader/movieHeaderFocus.sss';

export default class FocusMovieHeaderEditor extends MovieHeaderEditor {
	s = s;

	getDefaultLinks() {
		return {
			home: { id: 'home', name: this.props.content?.title || 'Home', order: 0, permanent: true },
			videos: { id: 'videos', name: 'Videos', order: 1, default: true },
			showtimes: { id: 'showtimes', name: 'Tickets', order: 2, default: true },
			homeEnt: { id: 'homeEnt', name: 'Watch at Home', order: 3, default: true },
		};
	}

	renderLogo() {
		return <FocusFeaturesLogo width="112" height="40" />;
	}
}